import React, { useCallback, Fragment, ReactElement } from 'react';
import FlexContainer from '../../../components/flex-container/flex-container.component';
import ModalLayout from '../../../components/modal-layout/modal-layout.component';
import NoContentBlock from '../../../components/no-content-block/no-content-block.component';
import ModalSwipeableSlider from '../../../components/modal-swipeable-slider/modal-swipeable-slider.component';
import useScreenMobile from '../../../hooks/use-screen-mobile';

const DealPhotosModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    dealData,
    dealPhotoActiveId,
    dealPhotoList,
    onCloseModal,
  } = props;

  const isMobileScreen: boolean = useScreenMobile();

  const closeModal: Function = useCallback((): void => {
    if (onCloseModal) {
      onCloseModal();
    }
  }, []);

  return (
    <Fragment>
      {
        !isMobileScreen && (
          <ModalLayout isMedium withNoHeader isOpen={isOpen} title="Deal Photos" onCloseModal={closeModal}>
            <FlexContainer isCentered>
              {
                (dealPhotoList && !!dealPhotoList.length) ? (
                  <ModalSwipeableSlider
                    imageList={dealPhotoList}
                    imageActiveId={dealPhotoActiveId}
                    imageTextPrefix={dealData ? dealData.name : 'Deal'}
                  />
                ) : (
                  <NoContentBlock>
                    No photos
                  </NoContentBlock>
                )
              }
            </FlexContainer>
          </ModalLayout>
        )
      }
    </Fragment>
  );
});

export default DealPhotosModal;
